import React from "react";
import PropTypes from "prop-types";
import ManagementsUnitJson from "../../../content/json/components/menu-managements-units.json";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import TreeChildren from "../../catalog/sideMenu/TreeChildren";
import PlannigTreeChildren from "./plannigTreeChildren";
import MyContext from "../../../api/context/my-context";
import SideMenuBottom from "./SideMenuBottom";
import * as omnimap from "../../../api/omnimap/omnimapActions";
import * as CommonFunctions from "./functions/commonFunctions";
class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      token: null,
      treeList: [],
      treeCount: 0,
      treekey: props.treekey,
      isLoading: true,
      pureTreeList: [],
    };
  }

  handleEvent() {
    var tree = this.state.treeList;
    var treePure = this.state.pureTreeList;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treekey: this.props.treekey,
      treeCount: this.state.treeCount,
      isLoading: this.state.isLoading,
      pureTreeList: treePure,
    };
  }

  plannigTreeModel = [];
  list = [];
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  async GetTreeStructure(model) {
    var that = this;
    that.setState({ isLoading: true });
    window.$mm_side_menu_tree_key = this.state.treekey;
    let result = await omnimap.FillTableAction(model, 1, this.state.token);

    var data = result.data;
    if (data != undefined) {
      that.list = [];
      for (let i = 0; i < data.length; i++) {
        that.list.push({
          name: data[i].name,
          id: data[i].identification,
          isSubfolder: data[i].content["algemeen-issubfolder"],
          parentfolder: data[i].content["algemeen-parentfolder"],
          children: null,
        });
      }
      that.setState({ treeList: [], pureTreeList: [] });

      if (that.state.treekey === "werkplannen") {
        var treeResult = await CommonFunctions.plannigListToTree(that.list, 0);
        that.setState({
          treeList: treeResult[0].sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          }),
          isLoading: false,
          pureTreeList: treeResult[1] /*that.list*/,
        });
      } else {
        that.setState({
          treeList: CommonFunctions.listToTree(that.list, 0).sort(function (
            a,
            b
          ) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }),
          isLoading: false,
          pureTreeList: that.list,
        });
      }

      that.setState({ treeCount: that.list.length });
    } else {
      that.setState({ treeList: [], pureTreeList: [], isLoading: false });
      that.setState({ treeCount: null });
    }

    if (that.state.treekey === "budget") {
      var treeResult = await CommonFunctions.budgetListToTree();
      that.setState({
        treeList: treeResult.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        }),
        isLoading: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      var model = {
        content: [
          {
            key: "algemeen-isvoor",
            and_or: "AND",
            values: [that.state.treekey],
            datatype: "STRING",
          },
        ],
        definitions: [process.env.REACT_APP_TREE],
      };

      that.GetTreeStructure(model);
      $("#side-menu-treeButton").click();
    }
  }

  async componentDidMount() {
    var that = this;
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenPopup(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
        treeList: null,
      });
    }

    await that.GetTreeStructure(that.model);
  }

  render() {
    this.handleEvent();

    if (this.state.menuName == "management-maintenance") {
      var menuList = ManagementsUnitJson.menus;
    }
    return (
      <ul className="left-menu ul">
        {menuList.map((s) => (
          <div>
            {s.componentName == this.state.tabName ? (
              <li key={s.id.toString()}>
                <NavLink
                  className="icon-filter-act"
                  to={{
                    pathname: "/management-maintenance/" + s.componentName,
                    componentName: s.componentName,
                    isDidUpdate: "0038",
                  }}
                >
                  <span className={s.icon} />
                  {s.name}
                  <span
                    class={
                      s.isTree && this.state.isLoading
                        ? "spinner-border spinner-border-sm"
                        : ""
                    }
                    role="status"
                    aria-hidden="true"
                  ></span>
                </NavLink>
              </li>
            ) : (
              <li key={s.id.toString()}>
                <NavLink
                  className=""
                  to={{
                    pathname: "/management-maintenance/" + s.componentName,
                    componentName: s.componentName,
                    isDidUpdate: "0038",
                  }}
                >
                  <span className={s.icon} />
                  {s.name}
                </NavLink>
              </li>
            )}
            {s.isTree ? (
              this.state.treeList.length > 0 ? (
                s.componentName === this.state.tabName ? (
                  <MyContext.Consumer>
                    {(context) => (
                      <div>
                        {this.state.treekey === "werkplannaam" ? (
                          <PlannigTreeChildren
                            TreeList={
                              context.store.treeCount == null
                                ? this.state.treeList
                                : context.store.treeCount !=
                                  this.state.treeCount
                                ? context.store.treeList
                                : this.state.treeList
                            }
                            TreeCountUpdate={context.store.treeCount}
                            TreeCount={this.state.treeCount}
                            componentName={s.componentName}
                            pathname={this.state.menuName}
                            pureTree={this.state.pureTreeList}
                          />
                        ) : (
                          <TreeChildren
                            TreeList={
                              context.store.treeCount == null
                                ? this.state.treeList
                                : context.store.treeCount !=
                                  this.state.treeCount
                                ? context.store.treeList
                                : this.state.treeList
                            }
                            TreeCountUpdate={context.store.treeCount}
                            TreeCount={this.state.treeCount}
                            componentName={s.componentName}
                            pathname={this.state.menuName}
                            pureTree={this.state.pureTreeList}
                          />
                        )}
                      </div>
                    )}
                  </MyContext.Consumer>
                ) : (
                  ""
                )
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
        ))}
      </ul>
    );
  }
}

SideMenu.propTypes = {
  menuName: PropTypes.string.isRequired,
  tabName: PropTypes.string.isRequired,
};

export default SideMenu;
